export const messages = {
    'header.logo.alt': 'WeaVR Manager logo',
    'header.menu.open': 'Open menu',
    'header.menu.close': 'Close menu',
    'mainMenu.companies': 'Companies',
    'mainMenu.users': 'Users',
    'mainMenu.groups': 'Groups',
    'mainMenu.procedures': 'Procedures',
    'mainMenu.collaboration': 'Collaboration',
    'mainMenu.analytics': 'Analytics',
    'mainMenu.licenses': 'Licenses',
    'mainMenu.download': 'Resources',
    'userMenu.profile': 'My profile',
    'userMenu.pairDevice': 'Pair a device',
    'userMenu.pairedDevices': 'Paired devices',
    'userMenu.requestOtp': 'Request OTP',
    'userMenu.integrations': 'Integrations',
    'userMenu.logout': 'Logout',
}
